import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyDBqVVWQz0V1Ou_sJvGvCYMJnw_PSQeb7w",
  authDomain: "blooming-16a57.firebaseapp.com",
  projectId: "blooming-16a57",
  storageBucket: "blooming-16a57.firebasestorage.app",
  messagingSenderId: "736109599650",
  appId: "1:736109599650:web:8940afc37cfd0bc243f0fb",
  measurementId: "G-5090DC8S4V"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const analytics = getAnalytics(app)

export { db, analytics }
export default app
